import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineGroupedSummaryGetAsyncSlice } from './get';

export const coreTimelineGroupedSummaryReducers = combineReducers({
	get: coreTimelineGroupedSummaryGetAsyncSlice.asyncReducers
});

export const coreTimelineGroupedSummaryWatchers = combineAllWatchers([
	coreTimelineGroupedSummaryGetAsyncSlice.asyncWatchers
]);
